type Country = {
  countryCode: any;
  continent: string;
  phone: number[];
  name: string;
  flag: string;
};

export const countryArray: Country[] = [
  {
    countryCode: 'AF',
    continent: 'AS',
    phone: [93],
    name: 'afghanistan',
    flag: '🇦🇫'
  },
  {
    countryCode: 'AL',
    continent: 'EU',
    phone: [355],
    name: 'albania',
    flag: '🇦🇱'
  },
  {
    countryCode: 'DZ',
    continent: 'AF',
    phone: [213],
    name: 'algeria',
    flag: '🇩🇿'
  },
  {
    countryCode: 'AS',
    continent: 'OC',
    phone: [1684],
    name: 'american samoa',
    flag: '🇦🇸'
  },
  {
    countryCode: 'AD',
    continent: 'EU',
    phone: [376],
    name: 'andorra',
    flag: '🇦🇩'
  },
  {
    countryCode: 'AO',
    continent: 'AF',
    phone: [244],
    name: 'angola',
    flag: '🇦🇴'
  },
  {
    countryCode: 'AI',
    continent: 'NA',
    phone: [1264],
    name: 'anguilla',
    flag: '🇦🇮'
  },
  {
    countryCode: 'AQ',
    continent: 'AN',
    phone: [672],
    name: 'antarctica',
    flag: '🇦🇶'
  },
  {
    countryCode: 'AG',
    continent: 'NA',
    phone: [1268],
    name: 'antigua and barbuda',
    flag: '🇦🇬'
  },
  {
    countryCode: 'AR',
    continent: 'SA',
    phone: [54],
    name: 'argentina',
    flag: '🇦🇷'
  },
  {
    countryCode: 'AM',
    continent: 'AS',
    phone: [374],
    name: 'armenia',
    flag: '🇦🇲'
  },
  {
    countryCode: 'AW',
    continent: 'NA',
    phone: [297],
    name: 'aruba',
    flag: '🇦🇼'
  },
  {
    countryCode: 'AU',
    continent: 'OC',
    phone: [61],
    name: 'australia',
    flag: '🇦🇺'
  },
  {
    countryCode: 'AT',
    continent: 'EU',
    phone: [43],
    name: 'austria',
    flag: '🇦🇹'
  },
  {
    countryCode: 'AZ',
    continent: 'AS',
    phone: [994],
    name: 'azerbaijan',
    flag: '🇦🇿'
  },
  {
    countryCode: 'BS',
    continent: 'NA',
    phone: [1242],
    name: 'bahamas',
    flag: '🇧🇸'
  },
  {
    countryCode: 'BH',
    continent: 'AS',
    phone: [973],
    name: 'bahrain',
    flag: '🇧🇭'
  },
  {
    countryCode: 'BD',
    continent: 'AS',
    phone: [880],
    name: 'bangladesh',
    flag: '🇧🇩'
  },
  {
    countryCode: 'BB',
    continent: 'NA',
    phone: [1246],
    name: 'barbados',
    flag: '🇧🇧'
  },
  {
    countryCode: 'BY',
    continent: 'EU',
    phone: [375],
    name: 'belarus',
    flag: '🇧🇾'
  },
  {
    countryCode: 'BE',
    continent: 'EU',
    phone: [32],
    name: 'belgium',
    flag: '🇧🇪'
  },
  {
    countryCode: 'BZ',
    continent: 'NA',
    phone: [501],
    name: 'belize',
    flag: '🇧🇿'
  },
  {
    countryCode: 'BJ',
    continent: 'AF',
    phone: [229],
    name: 'benin',
    flag: '🇧🇯'
  },
  {
    countryCode: 'BM',
    continent: 'NA',
    phone: [1441],
    name: 'bermuda',
    flag: '🇧🇲'
  },
  {
    countryCode: 'BT',
    continent: 'AS',
    phone: [975],
    name: 'bhutan',
    flag: '🇧🇹'
  },
  {
    countryCode: 'BO',
    continent: 'SA',
    phone: [591],
    name: 'bolivia',
    flag: '🇧🇴'
  },
  {
    countryCode: 'BQ',
    continent: 'NA',
    phone: [5997],
    name: 'bonaire',
    flag: '🇧🇶'
  },
  {
    countryCode: 'BA',
    continent: 'EU',
    phone: [387],
    name: 'bosnia and herzegovina',
    flag: '🇧🇦'
  },
  {
    countryCode: 'BW',
    continent: 'AF',
    phone: [267],
    name: 'botswana',
    flag: '🇧🇼'
  },
  {
    countryCode: 'BV',
    continent: 'AN',
    phone: [47],
    name: 'bouvet island',
    flag: '🇧🇻'
  },
  {
    countryCode: 'BR',
    continent: 'SA',
    phone: [55],
    name: 'brazil',
    flag: '🇧🇷'
  },
  {
    countryCode: 'IO',
    continent: 'AS',
    phone: [246],
    name: 'british indian ocean territory',
    flag: '🇮🇴'
  },
  {
    countryCode: 'VG',
    continent: 'NA',
    phone: [1284],
    name: 'british virgin islands',
    flag: '🇻🇬'
  },
  {
    countryCode: 'BN',
    continent: 'AS',
    phone: [673],
    name: 'brunei',
    flag: '🇧🇳'
  },
  {
    countryCode: 'BG',
    continent: 'EU',
    phone: [359],
    name: 'bulgaria',
    flag: '🇧🇬'
  },
  {
    countryCode: 'BF',
    continent: 'AF',
    phone: [226],
    name: 'burkina faso',
    flag: '🇧🇫'
  },
  {
    countryCode: 'BI',
    continent: 'AF',
    phone: [257],
    name: 'burundi',
    flag: '🇧🇮'
  },
  {
    countryCode: 'KH',
    continent: 'AS',
    phone: [855],
    name: 'cambodia',
    flag: '🇰🇭'
  },
  {
    countryCode: 'CM',
    continent: 'AF',
    phone: [237],
    name: 'cameroon',
    flag: '🇨🇲'
  },
  {
    countryCode: 'CA',
    continent: 'NA',
    phone: [1],
    name: 'canada',
    flag: '🇨🇦'
  },
  {
    countryCode: 'CV',
    continent: 'AF',
    phone: [238],
    name: 'cape verde',
    flag: '🇨🇻'
  },
  {
    countryCode: 'KY',
    continent: 'NA',
    phone: [1345],
    name: 'cayman islands',
    flag: '🇰🇾'
  },
  {
    countryCode: 'CF',
    continent: 'AF',
    phone: [236],
    name: 'central african republic',
    flag: '🇨🇫'
  },
  {
    countryCode: 'TD',
    continent: 'AF',
    phone: [235],
    name: 'chad',
    flag: '🇹🇩'
  },
  {
    countryCode: 'CL',
    continent: 'SA',
    phone: [56],
    name: 'chile',
    flag: '🇨🇱'
  },
  {
    countryCode: 'CN',
    continent: 'AS',
    phone: [86],
    name: 'china',
    flag: '🇨🇳'
  },
  {
    countryCode: 'CX',
    continent: 'AS',
    phone: [61],
    name: 'christmas island',
    flag: '🇨🇽'
  },
  {
    countryCode: 'CC',
    continent: 'AS',
    phone: [61],
    name: 'cocos [keeling] islands',
    flag: '🇨🇨'
  },
  {
    countryCode: 'CO',
    continent: 'SA',
    phone: [57],
    name: 'colombia',
    flag: '🇨🇴'
  },
  {
    countryCode: 'KM',
    continent: 'AF',
    phone: [269],
    name: 'comoros',
    flag: '🇰🇲'
  },
  {
    countryCode: 'CK',
    continent: 'OC',
    phone: [682],
    name: 'cook islands',
    flag: '🇨🇰'
  },
  {
    countryCode: 'CR',
    continent: 'NA',
    phone: [506],
    name: 'costa rica',
    flag: '🇨🇷'
  },
  {
    countryCode: 'HR',
    continent: 'EU',
    phone: [385],
    name: 'croatia',
    flag: '🇭🇷'
  },
  { countryCode: 'CU', continent: 'NA', phone: [53], name: 'cuba', flag: '🇨🇺' },
  {
    countryCode: 'CW',
    continent: 'NA',
    phone: [5999],
    name: 'curacao',
    flag: '🇨🇼'
  },
  {
    countryCode: 'CY',
    continent: 'EU',
    phone: [357],
    name: 'cyprus',
    flag: '🇨🇾'
  },
  {
    countryCode: 'CZ',
    continent: 'EU',
    phone: [420],
    name: 'czech republic',
    flag: '🇨🇿'
  },
  {
    countryCode: 'CD',
    continent: 'AF',
    phone: [243],
    name: 'democratic republic of the congo',
    flag: '🇨🇩'
  },
  {
    countryCode: 'DK',
    continent: 'EU',
    phone: [45],
    name: 'denmark',
    flag: '🇩🇰'
  },
  {
    countryCode: 'DJ',
    continent: 'AF',
    phone: [253],
    name: 'djibouti',
    flag: '🇩🇯'
  },
  {
    countryCode: 'DM',
    continent: 'NA',
    phone: [1767],
    name: 'dominica',
    flag: '🇩🇲'
  },
  {
    countryCode: 'DO',
    continent: 'NA',
    phone: [1809, 1829, 1849],
    name: 'dominican republic',
    flag: '🇩🇴'
  },
  {
    countryCode: 'TL',
    continent: 'OC',
    phone: [670],
    name: 'east timor',
    flag: '🇹🇱'
  },
  {
    countryCode: 'EC',
    continent: 'SA',
    phone: [593],
    name: 'ecuador',
    flag: '🇪🇨'
  },
  {
    countryCode: 'EG',
    continent: 'AF',
    phone: [20],
    name: 'egypt',
    flag: '🇪🇬'
  },
  {
    countryCode: 'SV',
    continent: 'NA',
    phone: [503],
    name: 'el salvador',
    flag: '🇸🇻'
  },
  {
    countryCode: 'GQ',
    continent: 'AF',
    phone: [240],
    name: 'equatorial guinea',
    flag: '🇬🇶'
  },
  {
    countryCode: 'ER',
    continent: 'AF',
    phone: [291],
    name: 'eritrea',
    flag: '🇪🇷'
  },
  {
    countryCode: 'EE',
    continent: 'EU',
    phone: [372],
    name: 'estonia',
    flag: '🇪🇪'
  },
  {
    countryCode: 'ET',
    continent: 'AF',
    phone: [251],
    name: 'ethiopia',
    flag: '🇪🇹'
  },
  {
    countryCode: 'FK',
    continent: 'SA',
    phone: [500],
    name: 'falkland islands',
    flag: '🇫🇰'
  },
  {
    countryCode: 'FO',
    continent: 'EU',
    phone: [298],
    name: 'faroe islands',
    flag: '🇫🇴'
  },
  {
    countryCode: 'FJ',
    continent: 'OC',
    phone: [679],
    name: 'fiji',
    flag: '🇫🇯'
  },
  {
    countryCode: 'FI',
    continent: 'EU',
    phone: [358],
    name: 'finland',
    flag: '🇫🇮'
  },
  {
    countryCode: 'FR',
    continent: 'EU',
    phone: [33],
    name: 'france',
    flag: '🇫🇷'
  },
  {
    countryCode: 'GF',
    continent: 'SA',
    phone: [594],
    name: 'french guiana',
    flag: '🇬🇫'
  },
  {
    countryCode: 'PF',
    continent: 'OC',
    phone: [689],
    name: 'french polynesia',
    flag: '🇵🇫'
  },
  {
    countryCode: 'TF',
    continent: 'AN',
    phone: [262],
    name: 'french southern territories',
    flag: '🇹🇫'
  },
  {
    countryCode: 'GA',
    continent: 'AF',
    phone: [241],
    name: 'gabon',
    flag: '🇬🇦'
  },
  {
    countryCode: 'GM',
    continent: 'AF',
    phone: [220],
    name: 'gambia',
    flag: '🇬🇲'
  },
  {
    countryCode: 'GE',
    continent: 'AS',
    phone: [995],
    name: 'georgia',
    flag: '🇬🇪'
  },
  {
    countryCode: 'DE',
    continent: 'EU',
    phone: [49],
    name: 'germany',
    flag: '🇩🇪'
  },
  {
    countryCode: 'GH',
    continent: 'AF',
    phone: [233],
    name: 'ghana',
    flag: '🇬🇭'
  },
  {
    countryCode: 'GI',
    continent: 'EU',
    phone: [350],
    name: 'gibraltar',
    flag: '🇬🇮'
  },
  {
    countryCode: 'GR',
    continent: 'EU',
    phone: [30],
    name: 'greece',
    flag: '🇬🇷'
  },
  {
    countryCode: 'GL',
    continent: 'NA',
    phone: [299],
    name: 'greenland',
    flag: '🇬🇱'
  },
  {
    countryCode: 'GD',
    continent: 'NA',
    phone: [1473],
    name: 'grenada',
    flag: '🇬🇩'
  },
  {
    countryCode: 'GP',
    continent: 'NA',
    phone: [590],
    name: 'guadeloupe',
    flag: '🇬🇵'
  },
  {
    countryCode: 'GU',
    continent: 'OC',
    phone: [1671],
    name: 'guam',
    flag: '🇬🇺'
  },
  {
    countryCode: 'GT',
    continent: 'NA',
    phone: [502],
    name: 'guatemala',
    flag: '🇬🇹'
  },
  {
    countryCode: 'GG',
    continent: 'EU',
    phone: [44],
    name: 'guernsey',
    flag: '🇬🇬'
  },
  {
    countryCode: 'GN',
    continent: 'AF',
    phone: [224],
    name: 'guinea',
    flag: '🇬🇳'
  },
  {
    countryCode: 'GW',
    continent: 'AF',
    phone: [245],
    name: 'guinea-bissau',
    flag: '🇬🇼'
  },
  {
    countryCode: 'GY',
    continent: 'SA',
    phone: [592],
    name: 'guyana',
    flag: '🇬🇾'
  },
  {
    countryCode: 'HT',
    continent: 'NA',
    phone: [509],
    name: 'haiti',
    flag: '🇭🇹'
  },
  {
    countryCode: 'HM',
    continent: 'AN',
    phone: [61],
    name: 'heard island and mcdonald islands',
    flag: '🇭🇲'
  },
  {
    countryCode: 'HN',
    continent: 'NA',
    phone: [504],
    name: 'honduras',
    flag: '🇭🇳'
  },
  {
    countryCode: 'HK',
    continent: 'AS',
    phone: [852],
    name: 'hong kong',
    flag: '🇭🇰'
  },
  {
    countryCode: 'HU',
    continent: 'EU',
    phone: [36],
    name: 'hungary',
    flag: '🇭🇺'
  },
  {
    countryCode: 'IS',
    continent: 'EU',
    phone: [354],
    name: 'iceland',
    flag: '🇮🇸'
  },
  {
    countryCode: 'IN',
    continent: 'AS',
    phone: [91],
    name: 'india',
    flag: '🇮🇳'
  },
  {
    countryCode: 'ID',
    continent: 'AS',
    phone: [62],
    name: 'indonesia',
    flag: '🇮🇩'
  },
  { countryCode: 'IR', continent: 'AS', phone: [98], name: 'iran', flag: '🇮🇷' },
  {
    countryCode: 'IQ',
    continent: 'AS',
    phone: [964],
    name: 'iraq',
    flag: '🇮🇶'
  },
  {
    countryCode: 'IE',
    continent: 'EU',
    phone: [353],
    name: 'ireland',
    flag: '🇮🇪'
  },
  {
    countryCode: 'IM',
    continent: 'EU',
    phone: [44],
    name: 'isle of man',
    flag: '🇮🇲'
  },
  {
    countryCode: 'IL',
    continent: 'AS',
    phone: [972],
    name: 'israel',
    flag: '🇮🇱'
  },
  {
    countryCode: 'IT',
    continent: 'EU',
    phone: [39],
    name: 'italy',
    flag: '🇮🇹'
  },
  {
    countryCode: 'CI',
    continent: 'AF',
    phone: [225],
    name: 'ivory coast',
    flag: '🇨🇮'
  },
  {
    countryCode: 'JM',
    continent: 'NA',
    phone: [1876],
    name: 'jamaica',
    flag: '🇯🇲'
  },
  {
    countryCode: 'JP',
    continent: 'AS',
    phone: [81],
    name: 'japan',
    flag: '🇯🇵'
  },
  {
    countryCode: 'JE',
    continent: 'EU',
    phone: [44],
    name: 'jersey',
    flag: '🇯🇪'
  },
  {
    countryCode: 'JO',
    continent: 'AS',
    phone: [962],
    name: 'jordan',
    flag: '🇯🇴'
  },
  {
    countryCode: 'KZ',
    continent: 'AS',
    phone: [76, 77],
    name: 'kazakhstan',
    flag: '🇰🇿'
  },
  {
    countryCode: 'KE',
    continent: 'AF',
    phone: [254],
    name: 'kenya',
    flag: '🇰🇪'
  },
  {
    countryCode: 'KI',
    continent: 'OC',
    phone: [686],
    name: 'kiribati',
    flag: '🇰🇮'
  },
  {
    countryCode: 'XK',
    continent: 'EU',
    phone: [377, 381, 383, 386],
    name: 'kosovo',
    flag: '🇽🇰'
  },
  {
    countryCode: 'KW',
    continent: 'AS',
    phone: [965],
    name: 'kuwait',
    flag: '🇰🇼'
  },
  {
    countryCode: 'KG',
    continent: 'AS',
    phone: [996],
    name: 'kyrgyzstan',
    flag: '🇰🇬'
  },
  {
    countryCode: 'LA',
    continent: 'AS',
    phone: [856],
    name: 'laos',
    flag: '🇱🇦'
  },
  {
    countryCode: 'LV',
    continent: 'EU',
    phone: [371],
    name: 'latvia',
    flag: '🇱🇻'
  },
  {
    countryCode: 'LB',
    continent: 'AS',
    phone: [961],
    name: 'lebanon',
    flag: '🇱🇧'
  },
  {
    countryCode: 'LS',
    continent: 'AF',
    phone: [266],
    name: 'lesotho',
    flag: '🇱🇸'
  },
  {
    countryCode: 'LR',
    continent: 'AF',
    phone: [231],
    name: 'liberia',
    flag: '🇱🇷'
  },
  {
    countryCode: 'LY',
    continent: 'AF',
    phone: [218],
    name: 'libya',
    flag: '🇱🇾'
  },
  {
    countryCode: 'LI',
    continent: 'EU',
    phone: [423],
    name: 'liechtenstein',
    flag: '🇱🇮'
  },
  {
    countryCode: 'LT',
    continent: 'EU',
    phone: [370],
    name: 'lithuania',
    flag: '🇱🇹'
  },
  {
    countryCode: 'LU',
    continent: 'EU',
    phone: [352],
    name: 'luxembourg',
    flag: '🇱🇺'
  },
  {
    countryCode: 'MO',
    continent: 'AS',
    phone: [853],
    name: 'macao',
    flag: '🇲🇴'
  },
  {
    countryCode: 'MG',
    continent: 'AF',
    phone: [261],
    name: 'madagascar',
    flag: '🇲🇬'
  },
  {
    countryCode: 'MW',
    continent: 'AF',
    phone: [265],
    name: 'malawi',
    flag: '🇲🇼'
  },
  {
    countryCode: 'MY',
    continent: 'AS',
    phone: [60],
    name: 'malaysia',
    flag: '🇲🇾'
  },
  {
    countryCode: 'MV',
    continent: 'AS',
    phone: [960],
    name: 'maldives',
    flag: '🇲🇻'
  },
  {
    countryCode: 'ML',
    continent: 'AF',
    phone: [223],
    name: 'mali',
    flag: '🇲🇱'
  },
  {
    countryCode: 'MT',
    continent: 'EU',
    phone: [356],
    name: 'malta',
    flag: '🇲🇹'
  },
  {
    countryCode: 'MH',
    continent: 'OC',
    phone: [692],
    name: 'marshall islands',
    flag: '🇲🇭'
  },
  {
    countryCode: 'MQ',
    continent: 'NA',
    phone: [596],
    name: 'martinique',
    flag: '🇲🇶'
  },
  {
    countryCode: 'MR',
    continent: 'AF',
    phone: [222],
    name: 'mauritania',
    flag: '🇲🇷'
  },
  {
    countryCode: 'MU',
    continent: 'AF',
    phone: [230],
    name: 'mauritius',
    flag: '🇲🇺'
  },
  {
    countryCode: 'YT',
    continent: 'AF',
    phone: [262],
    name: 'mayotte',
    flag: '🇾🇹'
  },
  {
    countryCode: 'MX',
    continent: 'NA',
    phone: [52],
    name: 'mexico',
    flag: '🇲🇽'
  },
  {
    countryCode: 'FM',
    continent: 'OC',
    phone: [691],
    name: 'micronesia',
    flag: '🇫🇲'
  },
  {
    countryCode: 'MD',
    continent: 'EU',
    phone: [373],
    name: 'moldova',
    flag: '🇲🇩'
  },
  {
    countryCode: 'MC',
    continent: 'EU',
    phone: [377],
    name: 'monaco',
    flag: '🇲🇨'
  },
  {
    countryCode: 'MN',
    continent: 'AS',
    phone: [976],
    name: 'mongolia',
    flag: '🇲🇳'
  },
  {
    countryCode: 'ME',
    continent: 'EU',
    phone: [382],
    name: 'montenegro',
    flag: '🇲🇪'
  },
  {
    countryCode: 'MS',
    continent: 'NA',
    phone: [1664],
    name: 'montserrat',
    flag: '🇲🇸'
  },
  {
    countryCode: 'MA',
    continent: 'AF',
    phone: [212],
    name: 'morocco',
    flag: '🇲🇦'
  },
  {
    countryCode: 'MZ',
    continent: 'AF',
    phone: [258],
    name: 'mozambique',
    flag: '🇲🇿'
  },
  {
    countryCode: 'MM',
    continent: 'AS',
    phone: [95],
    name: 'myanmar [burma]',
    flag: '🇲🇲'
  },
  {
    countryCode: 'NA',
    continent: 'AF',
    phone: [264],
    name: 'namibia',
    flag: '🇳🇦'
  },
  {
    countryCode: 'NR',
    continent: 'OC',
    phone: [674],
    name: 'nauru',
    flag: '🇳🇷'
  },
  {
    countryCode: 'NP',
    continent: 'AS',
    phone: [977],
    name: 'nepal',
    flag: '🇳🇵'
  },
  {
    countryCode: 'NL',
    continent: 'EU',
    phone: [31],
    name: 'netherlands',
    flag: '🇳🇱'
  },
  {
    countryCode: 'NC',
    continent: 'OC',
    phone: [687],
    name: 'new caledonia',
    flag: '🇳🇨'
  },
  {
    countryCode: 'NZ',
    continent: 'OC',
    phone: [64],
    name: 'new zealand',
    flag: '🇳🇿'
  },
  {
    countryCode: 'NI',
    continent: 'NA',
    phone: [505],
    name: 'nicaragua',
    flag: '🇳🇮'
  },
  {
    countryCode: 'NE',
    continent: 'AF',
    phone: [227],
    name: 'niger',
    flag: '🇳🇪'
  },
  {
    countryCode: 'NG',
    continent: 'AF',
    phone: [234],
    name: 'nigeria',
    flag: '🇳🇬'
  },
  {
    countryCode: 'NU',
    continent: 'OC',
    phone: [683],
    name: 'niue',
    flag: '🇳🇺'
  },
  {
    countryCode: 'NF',
    continent: 'OC',
    phone: [672],
    name: 'norfolk island',
    flag: '🇳🇫'
  },
  {
    countryCode: 'KP',
    continent: 'AS',
    phone: [850],
    name: 'north korea',
    flag: '🇰🇵'
  },
  {
    countryCode: 'MK',
    continent: 'EU',
    phone: [389],
    name: 'north macedonia',
    flag: '🇲🇰'
  },
  {
    countryCode: 'MP',
    continent: 'OC',
    phone: [1670],
    name: 'northern mariana islands',
    flag: '🇲🇵'
  },
  {
    countryCode: 'NO',
    continent: 'EU',
    phone: [47],
    name: 'norway',
    flag: '🇳🇴'
  },
  {
    countryCode: 'OM',
    continent: 'AS',
    phone: [968],
    name: 'oman',
    flag: '🇴🇲'
  },
  {
    countryCode: 'PK',
    continent: 'AS',
    phone: [92],
    name: 'pakistan',
    flag: '🇵🇰'
  },
  {
    countryCode: 'PW',
    continent: 'OC',
    phone: [680],
    name: 'palau',
    flag: '🇵🇼'
  },
  {
    countryCode: 'PS',
    continent: 'AS',
    phone: [970],
    name: 'palestine',
    flag: '🇵🇸'
  },
  {
    countryCode: 'PA',
    continent: 'NA',
    phone: [507],
    name: 'panama',
    flag: '🇵🇦'
  },
  {
    countryCode: 'PG',
    continent: 'OC',
    phone: [675],
    name: 'papua new guinea',
    flag: '🇵🇬'
  },
  {
    countryCode: 'PY',
    continent: 'SA',
    phone: [595],
    name: 'paraguay',
    flag: '🇵🇾'
  },
  {
    countryCode: 'PE',
    continent: 'SA',
    phone: [51],
    name: 'peru',
    flag: '🇵🇪'
  },
  {
    countryCode: 'PH',
    continent: 'AS',
    phone: [63],
    name: 'philippines',
    flag: '🇵🇭'
  },
  {
    countryCode: 'PN',
    continent: 'OC',
    phone: [64],
    name: 'pitcairn islands',
    flag: '🇵🇳'
  },
  {
    countryCode: 'PL',
    continent: 'EU',
    phone: [48],
    name: 'poland',
    flag: '🇵🇱'
  },
  {
    countryCode: 'PT',
    continent: 'EU',
    phone: [351],
    name: 'portugal',
    flag: '🇵🇹'
  },
  {
    countryCode: 'PR',
    continent: 'NA',
    phone: [1787, 1939],
    name: 'puerto rico',
    flag: '🇵🇷'
  },
  {
    countryCode: 'QA',
    continent: 'AS',
    phone: [974],
    name: 'qatar',
    flag: '🇶🇦'
  },
  {
    countryCode: 'CG',
    continent: 'AF',
    phone: [242],
    name: 'republic of the congo',
    flag: '🇨🇬'
  },
  {
    countryCode: 'RO',
    continent: 'EU',
    phone: [40],
    name: 'romania',
    flag: '🇷🇴'
  },
  {
    countryCode: 'RU',
    continent: 'EU',
    phone: [7],
    name: 'russia',
    flag: '🇷🇺'
  },
  {
    countryCode: 'RW',
    continent: 'AF',
    phone: [250],
    name: 'rwanda',
    flag: '🇷🇼'
  },
  {
    countryCode: 'RE',
    continent: 'AF',
    phone: [262],
    name: 'réunion',
    flag: '🇷🇪'
  },
  {
    countryCode: 'BL',
    continent: 'NA',
    phone: [590],
    name: 'saint barthélemy',
    flag: '🇧🇱'
  },
  {
    countryCode: 'SH',
    continent: 'AF',
    phone: [290],
    name: 'saint helena',
    flag: '🇸🇭'
  },
  {
    countryCode: 'KN',
    continent: 'NA',
    phone: [1869],
    name: 'saint kitts and nevis',
    flag: '🇰🇳'
  },
  {
    countryCode: 'LC',
    continent: 'NA',
    phone: [1758],
    name: 'saint lucia',
    flag: '🇱🇨'
  },
  {
    countryCode: 'MF',
    continent: 'NA',
    phone: [590],
    name: 'saint martin',
    flag: '🇲🇫'
  },
  {
    countryCode: 'PM',
    continent: 'NA',
    phone: [508],
    name: 'saint pierre and miquelon',
    flag: '🇵🇲'
  },
  {
    countryCode: 'VC',
    continent: 'NA',
    phone: [1784],
    name: 'saint vincent and the grenadines',
    flag: '🇻🇨'
  },
  {
    countryCode: 'WS',
    continent: 'OC',
    phone: [685],
    name: 'samoa',
    flag: '🇼🇸'
  },
  {
    countryCode: 'SM',
    continent: 'EU',
    phone: [378],
    name: 'san marino',
    flag: '🇸🇲'
  },
  {
    countryCode: 'SA',
    continent: 'AS',
    phone: [966],
    name: 'saudi arabia',
    flag: '🇸🇦'
  },
  {
    countryCode: 'SN',
    continent: 'AF',
    phone: [221],
    name: 'senegal',
    flag: '🇸🇳'
  },
  {
    countryCode: 'RS',
    continent: 'EU',
    phone: [381],
    name: 'serbia',
    flag: '🇷🇸'
  },
  {
    countryCode: 'SC',
    continent: 'AF',
    phone: [248],
    name: 'seychelles',
    flag: '🇸🇨'
  },
  {
    countryCode: 'SL',
    continent: 'AF',
    phone: [232],
    name: 'sierra leone',
    flag: '🇸🇱'
  },
  {
    countryCode: 'SG',
    continent: 'AS',
    phone: [65],
    name: 'singapore',
    flag: '🇸🇬'
  },
  {
    countryCode: 'SX',
    continent: 'NA',
    phone: [1721],
    name: 'sint maarten',
    flag: '🇸🇽'
  },
  {
    countryCode: 'SK',
    continent: 'EU',
    phone: [421],
    name: 'slovakia',
    flag: '🇸🇰'
  },
  {
    countryCode: 'SI',
    continent: 'EU',
    phone: [386],
    name: 'slovenia',
    flag: '🇸🇮'
  },
  {
    countryCode: 'SB',
    continent: 'OC',
    phone: [677],
    name: 'solomon islands',
    flag: '🇸🇧'
  },
  {
    countryCode: 'SO',
    continent: 'AF',
    phone: [252],
    name: 'somalia',
    flag: '🇸🇴'
  },
  {
    countryCode: 'ZA',
    continent: 'AF',
    phone: [27],
    name: 'south africa',
    flag: '🇿🇦'
  },
  {
    countryCode: 'GS',
    continent: 'AN',
    phone: [500],
    name: 'south georgia and the south sandwich islands',
    flag: '🇬🇸'
  },
  {
    countryCode: 'KR',
    continent: 'AS',
    phone: [82],
    name: 'south korea',
    flag: '🇰🇷'
  },
  {
    countryCode: 'SS',
    continent: 'AF',
    phone: [211],
    name: 'south sudan',
    flag: '🇸🇸'
  },
  {
    countryCode: 'ES',
    continent: 'EU',
    phone: [34],
    name: 'spain',
    flag: '🇪🇸'
  },
  {
    countryCode: 'LK',
    continent: 'AS',
    phone: [94],
    name: 'sri lanka',
    flag: '🇱🇰'
  },
  {
    countryCode: 'SD',
    continent: 'AF',
    phone: [249],
    name: 'sudan',
    flag: '🇸🇩'
  },
  {
    countryCode: 'SR',
    continent: 'SA',
    phone: [597],
    name: 'suriname',
    flag: '🇸🇷'
  },
  {
    countryCode: 'SJ',
    continent: 'EU',
    phone: [4779],
    name: 'svalbard and jan mayen',
    flag: '🇸🇯'
  },
  {
    countryCode: 'SZ',
    continent: 'AF',
    phone: [268],
    name: 'swaziland',
    flag: '🇸🇿'
  },
  {
    countryCode: 'SE',
    continent: 'EU',
    phone: [46],
    name: 'sweden',
    flag: '🇸🇪'
  },
  {
    countryCode: 'CH',
    continent: 'EU',
    phone: [41],
    name: 'switzerland',
    flag: '🇨🇭'
  },
  {
    countryCode: 'SY',
    continent: 'AS',
    phone: [963],
    name: 'syria',
    flag: '🇸🇾'
  },
  {
    countryCode: 'ST',
    continent: 'AF',
    phone: [239],
    name: 'são tomé and príncipe',
    flag: '🇸🇹'
  },
  {
    countryCode: 'TW',
    continent: 'AS',
    phone: [886],
    name: 'taiwan',
    flag: '🇹🇼'
  },
  {
    countryCode: 'TJ',
    continent: 'AS',
    phone: [992],
    name: 'tajikistan',
    flag: '🇹🇯'
  },
  {
    countryCode: 'TZ',
    continent: 'AF',
    phone: [255],
    name: 'tanzania',
    flag: '🇹🇿'
  },
  {
    countryCode: 'TH',
    continent: 'AS',
    phone: [66],
    name: 'thailand',
    flag: '🇹🇭'
  },
  {
    countryCode: 'TG',
    continent: 'AF',
    phone: [228],
    name: 'togo',
    flag: '🇹🇬'
  },
  {
    countryCode: 'TK',
    continent: 'OC',
    phone: [690],
    name: 'tokelau',
    flag: '🇹🇰'
  },
  {
    countryCode: 'TO',
    continent: 'OC',
    phone: [676],
    name: 'tonga',
    flag: '🇹🇴'
  },
  {
    countryCode: 'TT',
    continent: 'NA',
    phone: [1868],
    name: 'trinidad and tobago',
    flag: '🇹🇹'
  },
  {
    countryCode: 'TN',
    continent: 'AF',
    phone: [216],
    name: 'tunisia',
    flag: '🇹🇳'
  },
  {
    countryCode: 'TR',
    continent: 'AS',
    phone: [90],
    name: 'turkey',
    flag: '🇹🇷'
  },
  {
    countryCode: 'TM',
    continent: 'AS',
    phone: [993],
    name: 'turkmenistan',
    flag: '🇹🇲'
  },
  {
    countryCode: 'TC',
    continent: 'NA',
    phone: [1649],
    name: 'turks and caicos islands',
    flag: '🇹🇨'
  },
  {
    countryCode: 'TV',
    continent: 'OC',
    phone: [688],
    name: 'tuvalu',
    flag: '🇹🇻'
  },
  {
    countryCode: 'UM',
    continent: 'OC',
    phone: [1],
    name: 'u.s. minor outlying islands',
    flag: '🇺🇲'
  },
  {
    countryCode: 'VI',
    continent: 'NA',
    phone: [1340],
    name: 'u.s. virgin islands',
    flag: '🇻🇮'
  },
  {
    countryCode: 'UG',
    continent: 'AF',
    phone: [256],
    name: 'uganda',
    flag: '🇺🇬'
  },
  {
    countryCode: 'UA',
    continent: 'EU',
    phone: [380],
    name: 'ukraine',
    flag: '🇺🇦'
  },
  {
    countryCode: 'AE',
    continent: 'AS',
    phone: [971],
    name: 'united arab emirates',
    flag: '🇦🇪'
  },
  {
    countryCode: 'GB',
    continent: 'EU',
    phone: [44],
    name: 'united kingdom',
    flag: '🇬🇧'
  },
  {
    countryCode: 'US',
    continent: 'NA',
    phone: [1],
    name: 'united states',
    flag: '🇺🇸'
  },
  {
    countryCode: 'UY',
    continent: 'SA',
    phone: [598],
    name: 'uruguay',
    flag: '🇺🇾'
  },
  {
    countryCode: 'UZ',
    continent: 'AS',
    phone: [998],
    name: 'uzbekistan',
    flag: '🇺🇿'
  },
  {
    countryCode: 'VU',
    continent: 'OC',
    phone: [678],
    name: 'vanuatu',
    flag: '🇻🇺'
  },
  {
    countryCode: 'VA',
    continent: 'EU',
    phone: [379],
    name: 'vatican city',
    flag: '🇻🇦'
  },
  {
    countryCode: 'VE',
    continent: 'SA',
    phone: [58],
    name: 'venezuela',
    flag: '🇻🇪'
  },
  {
    countryCode: 'VN',
    continent: 'AS',
    phone: [84],
    name: 'vietnam',
    flag: '🇻🇳'
  },
  {
    countryCode: 'WF',
    continent: 'OC',
    phone: [681],
    name: 'wallis and futuna',
    flag: '🇼🇫'
  },
  {
    countryCode: 'EH',
    continent: 'AF',
    phone: [212],
    name: 'western sahara',
    flag: '🇪🇭'
  },
  {
    countryCode: 'YE',
    continent: 'AS',
    phone: [967],
    name: 'yemen',
    flag: '🇾🇪'
  },
  {
    countryCode: 'ZM',
    continent: 'AF',
    phone: [260],
    name: 'zambia',
    flag: '🇿🇲'
  },
  {
    countryCode: 'ZW',
    continent: 'AF',
    phone: [263],
    name: 'zimbabwe',
    flag: '🇿🇼'
  },
  {
    countryCode: 'AX',
    continent: 'EU',
    phone: [358],
    name: 'åland',
    flag: '🇦🇽'
  }
];
